export const CHANGE_ACTIVITY_ASSIGNEE_ERROR_VALIDATION_MESSAGE  = {
    400 : 'No other user available with required permission.',
    405 : 'This is not valid action on selected records'
}
